import React from 'react';
import { Button, FilePicker, Heading, Pane, SelectField, Spinner, toaster } from 'evergreen-ui';
import Request from '../../../util/Api';

class GamesWorkshopStockcheck extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            file: null,
            stockAccountId: '1',
            loading: false
        };
    }

    handleFileChange = (files) => {
        if (files && files.length > 0) {
            this.setState({ file: files[0] });
        }
    };

    handleStockAccountChange = (e) => {
        this.setState({ stockAccountId: e.target.value });
    };

    handleSubmit = async () => {
        const { file, stockAccountId } = this.state;

        if (!file) {
            toaster.warning('Please select an XLSX file first');
            return;
        }

        this.setState({ loading: true });

        try {
            const formData = new FormData();
            formData.append('file', file);

            const data = await Request.post(
                '/integrations/games-workshop/stockcheck',
                null,
                { stockAccountId },
                formData
            );

            // Download the resulting file
            const link = document.createElement('a');
            link.href = data.data;
            link.download = data.filename;
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);

            toaster.success('Stockcheck completed! File downloaded.');
        } catch (error) {
            console.error('Error:', error);
            toaster.danger(error.message || 'Failed to process stockcheck');
        } finally {
            this.setState({ loading: false });
        }
    };

    render() {
        const { loading, stockAccountId } = this.state;

        return (
            <Pane padding={24}>
                <Heading size={700} marginBottom={24}>Games Workshop Stockcheck</Heading>
                
                <Pane 
                    background="tint1" 
                    padding={24} 
                    borderRadius={8}
                    maxWidth={600}
                >
                    <Pane marginBottom={16}>
                        <Heading size={400} marginBottom={8}>
                            Upload Games Workshop XLSX File
                        </Heading>
                        <Pane marginBottom={8} color="muted">
                            This tool checks stock for products in the uploaded spreadsheet and populates the "Order" column.
                            Products with Module "BS:F" and zero stock will have Order = 1, otherwise Order = 0.
                        </Pane>
                    </Pane>

                    <Pane marginBottom={16}>
                        <SelectField
                            label="Stock Account"
                            value={stockAccountId}
                            onChange={this.handleStockAccountChange}
                            width={300}
                        >
                            <option value="1">Ploiesti (Stock Account 1)</option>
                            <option value="4">Brasov (Stock Account 4)</option>
                        </SelectField>
                    </Pane>

                    <Pane marginBottom={24}>
                        <FilePicker
                            onChange={this.handleFileChange}
                            placeholder="Select the XLSX file here!"
                            accept=".xlsx, .xls"
                            width={300}
                        />
                    </Pane>

                    <Button 
                        appearance="primary" 
                        onClick={this.handleSubmit}
                        disabled={loading}
                        iconBefore={loading ? <Spinner size={16} /> : null}
                    >
                        {loading ? 'Processing...' : 'Process & Download'}
                    </Button>
                </Pane>
            </Pane>
        );
    }
}

export default GamesWorkshopStockcheck;
